import { poiTypes } from "../../../server/lib/open-planet/poiTypes";
import resourceTypes from "../../../server/lib/open-planet/resourceTypes";
import { RESOURCE_KIND_MAP } from "../../../server/routes/constants";
import ListItem from "../pois/components/listItem";
import ListItemBookable from "../pois/components/listItemBookable";

const listItemTypes = {
  poi: {
    component: ListItem,
    title: "Top things to do",
    showCurrency: false,
    resource: resourceTypes.poi,
    kind: "",
    heading: "Top things to do in",
    abbrevTitle: "Top",
  },
  [poiTypes.sights.name]: {
    component: ListItem,
    title: poiTypes.sights.displayName,
    showCurrency: false,
    kind: poiTypes.sights.name,
    resource: resourceTypes.poi,
    heading: "attractions",
  },
  [resourceTypes.lodging]: {
    component: ListItemBookable,
    title: poiTypes.sleeping.displayName,
    showCurrency: false,
    resource: resourceTypes.lodging,
    heading: "hotels, hostels and more",
  },
  [poiTypes.activities.name]: {
    component: ListItemBookable,
    title: poiTypes.activities.displayName,
    showCurrency: false,
    kind: poiTypes.activities.name,
    resource: resourceTypes.partner_activity,
    heading: "activities, tickets and more",
  },
  [poiTypes.eating.name]: {
    component: ListItem,
    title: poiTypes.eating.displayName,
    showCurrency: false,
    kind: poiTypes.eating.name,
    resource: resourceTypes.poi,
    heading: "restaurants",
  },
  tours: {
    component: ListItemBookable,
    title: "Tours",
    showCurrency: false,
    kind: RESOURCE_KIND_MAP.tou,
    resource: resourceTypes.partner_activity,
    heading: "tours",
  },
  [poiTypes.entertainment.name]: {
    component: ListItem,
    title: poiTypes.entertainment.displayName,
    showCurrency: false,
    kind: poiTypes.entertainment.name,
    resource: resourceTypes.poi,
    heading: "entertainment",
  },
  [poiTypes.drinking_nightlife.name]: {
    component: ListItem,
    title: poiTypes.drinking_nightlife.displayName,
    showCurrency: false,
    kind: poiTypes.drinking_nightlife.name,
    resource: resourceTypes.poi,
    heading: "drinking and nightlife",
  },
  [poiTypes.shopping.name]: {
    component: ListItem,
    title: poiTypes.shopping.displayName,
    showCurrency: false,
    kind: poiTypes.shopping.name,
    resource: resourceTypes.poi,
    heading: "shopping",
  },
  [poiTypes.transport.name]: {
    component: ListItem,
    title: poiTypes.transport.displayName,
    showCurrency: false,
    kind: poiTypes.transport.name,
    hide: true,
    resource: resourceTypes.poi,
    heading: "",
  },
  [poiTypes.info.name]: {
    component: ListItem,
    title: poiTypes.info.displayName,
    showCurrency: false,
    kind: poiTypes.info.name,
    hide: true,
    resource: resourceTypes.poi,
    heading: "",
  },
  articles: {
    component: ListItem,
    title: "Articles",
    showCurrency: false,
    hide: true,
    resource: resourceTypes.articles,
    heading: "",
  },
  [poiTypes.festivals_events.name]: {
    component: ListItem,
    title: poiTypes.festivals_events.displayName,
    showCurrency: false,
    hide: true,
    kind: poiTypes.festivals_events.name,
    resource: resourceTypes.poi,
    heading: "",
  },
  collections: {
    component: ListItem,
    title: "Collections",
    showCurrency: false,
    hide: true,
    resource: resourceTypes.collections,
    kind: "collections",
    heading: "",
  },
};

export const visibleListItemTypes = Object.keys(listItemTypes)
  .map(key => listItemTypes[key])
  .filter(({ hide }) => !hide);

export const topThingsListItemTypes = [
  "drinking_nightlife",
  "entertainment",
  "shopping",
  "eating",
  "sights",
  "festivals_events",
].map(type => poiTypes[type].name);

export default listItemTypes;



// WEBPACK FOOTER //
// ./assets/shared/listItemTypes.js